import {
  IconButtonDatatable,
  Modal,
  SearchInput,
  TableWrapper,
} from "App/Component/ui";
import { TableRow, TableCell } from "@material-ui/core";
import { useDatatables } from "App/hooks";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { SelectIcon } from "App/Assets";
import React from "react";

const ModalBridge = ({ setShowModal, rowsBridge, formData, setFormData }) => {
  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      kodebridge: row?.kdpoli,
      codebridgepolibpjs: row?.kdpoli,
      codebridgesubspesialist: row?.kdsubspesialis,
    });
    setShowModal(false);
  };
  return (
    <Modal title={`Bridge`} width='60%' show={setShowModal}>
      <TableListBridge
        rows={rowsBridge}
        setShowModal={setShowModal}
        handleClickSelect={handleClickSelect}
      />
    </Modal>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "kdpoli",
    disablePadding: true,
    label: "KODE POLI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "kdsubspesialis",
    disablePadding: true,
    label: "KODE SUB SPESIALIS",
    align: "left",
  },
  {
    id: "nmpoli",
    disablePadding: true,
    label: "NAMA POLI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nmsubspesialis",
    disablePadding: true,
    label: "NAMA SUB SPESIALIS",
    align: "left",
    minWidth: "200px",
  },
];

const TableListBridge = ({ rows, handleClickSelect }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    setQ,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "kdpoli",
    orderByRow: ["kdpoli", "kdsubspesialis", "nmpoli", "nmsubspesialis"],
  });

  return (
    <>
      <div
        style={{
          width: "100%",
          padding: "1rem 0.5rem",
          display: "flex",
          justifyContent: "flex-end",
        }}>
        <SearchInput
          withIcon={true}
          onchange={(e) => setQ(e.target.value)}
          heightInput='0.5'
        />
      </div>
      <TableWrapper
        title=''
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        type='CUSTOM'
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <IconButtonDatatable
                    color='secondary'
                    aria-label='delete'
                    onClick={() => handleClickSelect(row)}
                    style={{
                      background: "#D8D8D8",
                      borderRadius: "8px",
                      padding: "6px",
                    }}>
                    <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                  </IconButtonDatatable>
                </TableCell>

                <TableCell align='left'>{row?.kdpoli}</TableCell>
                <TableCell align='left'>{row?.kdsubspesialis}</TableCell>
                <TableCell align='left'>{row?.nmpoli}</TableCell>
                <TableCell align='left'>{row?.nmsubspesialis}</TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
};

export default ModalBridge;
